import { useLayoutEffect, useState } from "react";
import appStyles from "../App.module.css";

export const useBreakpointClass = () => {
  const [bpClass, setBpClass] = useState<string>("");
  useLayoutEffect(() => {
    function updateClass() {
      setBpClass(
        window.innerWidth >= 1400
          ? appStyles.bfpXXL
          : window.innerWidth >= 1200
          ? appStyles.bfpXL
          : window.innerWidth >= 992
          ? appStyles.bfpLG
          : window.innerWidth >= 768
          ? appStyles.bfpMD
          : window.innerWidth >= 576
          ? appStyles.bfpSM
          : appStyles.bfpXS
      );
    }
    window.addEventListener("resize", updateClass);
    updateClass();
    return () => window.removeEventListener("resize", updateClass);
  }, []);
  return bpClass;
};
